<template>
    <div class="panel panel-default panel-dashboard">
        <loading-spinner v-if="loading"/>

        <div v-else class="panel-body">
            <table class="tw-w-full">
                <tbody>
                <tr
                    v-for="(participation, index) in participations"
                    class="tw-border tw-border-top tw-border-green-200"
                    :class="index % 2 === 0 ? 'tw-bg-white' : 'tw-bg-slate-100'"
                >
                    <td class="tw-w-4/12 tw-py-4 tw-px-2 tw-text-3xl">
                        {{ participation.attributes.competition_team_name }}
                    </td>

                    <td class="tw-w-5/12 tw-py-4 tw-px-2">
                        <div v-if="participation.attributes.current_progress">
                            <div class="tw-w-4/5 tw-h-4 tw-bg-green-200 tw-rounded-full">
                                <div
                                    class="tw-h-4 tw-rounded-full tw-bg-green-600"
                                    :style="{'width': Math.min(participation.attributes.current_progress.value / participation.attributes.current_progress.target * 100, 100)+ '%'}"
                                />
                            </div>

                            <span class="tw-text-xl">
                                {{ getFormattedValue(participation.attributes.current_progress.value) }}<span v-if="participation.attributes.current_progress.target"> / {{ getFormattedValue(participation.attributes.current_progress.target) }}</span>
                            </span>
                        </div>
                    </td>

                    <td class="tw-w-2/12 tw-py-4 tw-px-2 tw-text-3xl">
                      <span v-if="participation.attributes.competition_score_unit === 'number'">
                        {{ participation.attributes.score | number }}
                      </span>

                            <span v-else-if="participation.attributes.competition_score_unit === 'money'">
                        {{ participation.attributes.score | price }}
                      </span>

                            <span v-else-if="participation.attributes.competition_score_unit === 'stars'">
                        {{ participation.attributes.score }}&nbsp;&starf;
                      </span>

                            <span v-else>
                        {{ participation.attributes.score }}
                      </span>
                    </td>

                    <td class="tw-w-1/12 tw-py-4 tw-px-2 tw-text-center">
                        <button
                            type="button"
                            class="btn btn-sm tw-bg-transparent"
                            @click="$emit('select', participation.attributes.competition_team_id)"
                        >
                            <i class="fa fa-search"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
    components: {LoadingSpinner},

    props: {
        competition: {
            required: true
        }
    },

    data() {
        return {
            participations: null,

            loading: true,
            shared: store
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        competition() {
            this.load()
        }
    },

    methods: {
        load() {
            this.loading = true

            http.get('/api/v2/competitions/' + this.competition.id + '/participations')
                .then(response => {
                    this.participations = response.data.data

                    this.loading = false
                })
        },

        getFormattedValue(value) {
            if (this.competition.attributes.value_unit === 'number') {
                return this.$options.filters.number(value)
            }

            if (this.competition.attributes.value_unit === 'money') {
                return this.$options.filters.price(value)
            }

            return value
        }
    }
}
</script>
